import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/utils/request'
import apis from '@/apis/index'
import router from '../router/index'
import { getMenu } from '@/utils/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('token'),
    user: JSON.parse(sessionStorage.getItem('user') || '{}'),
    menus: [],
    unitList: [],
    deptList: [],
    buttonList: [],
    systemTitle: '智慧应用管理平台',
    keepAlive: []
  },
  mutations: {
    setToken (state, data) {
      state.token = data
      sessionStorage.setItem('token', data)
    },
    setUser (state, data) {
      state.user = data
      sessionStorage.setItem('user', JSON.stringify(data))
    },
    setUserMenus (state, data) {
      state.menus = data
    },
    setUnitList (state, data) {
      state.unitList = data
    },
    setPermission (state, path) {
      const menu = getMenu(state.menus, path)
      console.log('menumenumenu', menu)
      console.log('pathpathpath', path)
      state.buttonList = menu ? (menu.button || []) : []
    },
    setDeptList (state, data) {
      state.deptList = data
    },
    addKeepAlive (state, data) {
      if (!state.keepAlive.includes(data)) {
        state.keepAlive.push(data)
      }
    },
    removeKeepAlive (state, data) {
      const index = state.keepAlive.findIndex(item => item === data)
      state.keepAlive.splice(index, 1)
    }
  },
  actions: {
    loadUserMenus ({ commit }) {
      return axios.get(apis.system.selectSysMenuMyList, {
        menuType: '1'
      }).then(res => {
        commit('setUserMenus', res)
        commit('setPermission', router.currentRoute.path)
        sessionStorage.setItem('menus', JSON.stringify(res))
        return res
      })
    },
    // 企业列表
    getUnitList ({ commit }) {
      axios.get(apis.schoolCompany.selectSchoolByList).then(res => {
        commit('setUnitList', res.list)
      })
    },
    // 负责机构部门
    getDeptList ({ commit }) {
      axios.get(apis.system.selectSysDeptByList).then(res => {
        commit('setDeptList', res)
      })
    },
    setSystemTit ({ commit }, title) {
      commit('setSystemTitle', title)
    }
  },
  modules: {
  }
})
